import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { AppContext } from "../../context/context"
import { apiUrl, live } from "../../config/delcare"
import UiInput1 from "../../components/ui_input1"
import UiButton1 from "../../components/ui_button1"
import UiSpinner from "../../components/ui_spinner"

const ChangeEmail = () => {

    const navigate = useNavigate()
    const { neonUser, token, ww, validateEmail, fetchDataV2 } = useContext(AppContext)
    const { uuid, confirm_uuid } = useParams()
    const [otp, setOtp] = useState("")
    const [emailOtp, setEmailOtp] = useState(null)
    const [newEmail, setNewEmail] = useState("")
    const [error, setError] = useState("")
    const [load, setLoad] = useState(false)

    const submitHandler = async () => {
        setLoad(true)
        setError("")

        if (validateEmail(newEmail) == null) {
            setError("Email is invalid")
            setLoad(false)
            return
        }

        if (newEmail == neonUser.email) {
            setError("The provided email address is your current email address")
            setLoad(false)
            return
        }

        let query1 = "CHECK_EMAIL_EXISTS", params1 = [newEmail]
        let exists = await fetchDataV2(query1, params1, "/neon-query-v2")

        if (Number(exists[0].exists) > 0) {
            setError("Email is already in use.")
            setLoad(false)
            return
        }

        let query2 = "UPDATE_EMAIL_OTP", params2 = [newEmail, neonUser.user_id]

        try {
            let uuid_resp = await fetchDataV2(query2, params2, "/neon-query-v2")
            uuid_resp = uuid_resp.map(x => x.confirm_email_change_uuid)[0]

            verifyChangeEmailUuid()
            setLoad(true)

            let data = {
                "email_to": newEmail,
                otp_uuid: uuid,
                confirm_email_change_uuid: uuid_resp,
                "live": live
            }

            let url = `${apiUrl}/confirm_email_change`
            let resp = await fetch(url, {
                method: "POST",
                headers: (() => {
                    let myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("Authorization", "Bearer " + token.accessToken);
                    return myHeaders
                })(),
                body: JSON.stringify(data)
            })

            if (!resp.ok) {
                setLoad(false)
                return
            }

            setLoad(false)
            return
        }
        catch (err) {
            setLoad(false)
            return
        }
    }

    const confirmChangeEmail = async () => {
        setLoad(true)
        try {
            let query1 = "GET_USER_OTP", params1 = [uuid, confirm_uuid, neonUser.user_id]
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

            let resp2 = await fetch(`${apiUrl}/change-password`, {
                method: "POST",
                headers: (() => {
                    let myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("Authorization", "Bearer " + token.accessToken);
                    return myHeaders
                })(),
                body: JSON.stringify({
                    email: resp[0].new_email_address,
                    user_id: neonUser.user_id,
                })
            })

            if (!resp2.ok) return

            resp2 = await resp2.json()

            let query2 = "UPDATE_AUTH0_USER_EMAIL", params2 = [resp[0].new_email_address, neonUser.user_id]
            let query3 = "DELETE_USER_OTP", params3 = [neonUser.user_id]

            await fetchDataV2(query2, params2, "/neon-query-v2")
            await fetchDataV2(query3, params3, "/neon-query-v2")

            window.location.href = window.location.origin
        }
        catch (err) {
            return
        }
        finally {
            setLoad(false)
        }
    }

    const cancelChangeEmail = async () => {
        setLoad(true)
        let query1 = "DELETE_USER_OTP", params1 = [neonUser.user_id]
        await fetchDataV2(query1, params1, "/neon-query-v2")
        setLoad(false)
        navigate("/account")
    }

    const verifyChangeEmailUuid = async () => {
        let query1 = "VERIFY_CHANGE_EMAIL_UUID", params1 = [neonUser.user_id, uuid]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        if (resp.length > 0) {
            setOtp(uuid)
            setEmailOtp(resp)
        }
        return
    }

    useEffect(() => {
        if (uuid && confirm_uuid && neonUser.user_id) confirmChangeEmail()
    }, [uuid, confirm_uuid, neonUser])

    useEffect(() => {
        if (uuid && neonUser.user_id) verifyChangeEmailUuid()
    }, [uuid, neonUser])

    return (
        <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-1 pt-4 " : "p-4")}>
            {otp ?
                <div className="container1 pb-5">
                    {emailOtp && !emailOtp[0].new_email_address && <p className="fs-3">Enter new email address</p>}
                    {emailOtp && emailOtp[0].new_email_address && <p className="fs-3">Confirm new email address</p>}
                    {error && <p className="text-danger poppins mb-3">{error}</p>}

                    {emailOtp && emailOtp[0].new_email_address ?
                        <div style={{ maxWidth: 400 }}>
                            <p className="poppins">
                                We have sent a confirmation link to change your email to <span className="fw-bold">{emailOtp[0].new_email_address}</span>
                            </p>
                            {load ?
                                <UiSpinner />
                                :
                                <button className='small-btn' onClick={cancelChangeEmail}>Cancel Process</button>
                            }
                        </div>
                        :
                        <div className="d-flex flex-column gap-4" style={{ maxWidth: 400 }}>
                            <UiInput1 field="email" value={newEmail} userChangeHandler={setNewEmail} />
                            <div style={{ maxWidth: 300 }}>
                                {load ?
                                    <UiSpinner />
                                    :
                                    <UiButton1 text="Submit" submit={submitHandler} />
                                }
                            </div>
                        </div>
                    }
                </div>
                :
                "nothing to show here..."
            }
        </div>
    )
}

export default ChangeEmail